import { Calculation } from "@/services/backend/rlt/calculations/types/calculation";
import {
  updateRltCalculationCache,
  useRltCalculationPatchMutation,
  useRltCalculationResetReferenceNumberMutation,
} from "@/services/backend/rlt/calculations/api/calculation-api";
import { ReferenceNumberField } from "@/services/backend/documents/components/reference-number-field";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

/**
 * CalculationReferenceNumber edits the reference number of a calculation as a
 * row of the calculation card. A calculation owned by another document has no
 * number of its own, nothing is rendered for it.
 */
export function CalculationReferenceNumber({
  calculation,
  disabled,
}: {
  calculation: Calculation;
  disabled: boolean;
}) {
  const patchReferenceNumber = useRltCalculationPatchMutation();
  const resetReferenceNumber = useRltCalculationResetReferenceNumberMutation();

  // A calculation owned by another document has no number of its own.
  if (calculation.ownerId && !calculation.referenceNumber) {
    return null;
  }

  return (
    <div className="border-b px-6 py-3">
      <ReferenceNumberField
        data={calculation}
        updateCache={updateRltCalculationCache}
        patchMutation={patchReferenceNumber}
        resetMutation={resetReferenceNumber}
        disabled={disabled || isImmutable(calculation)}
      />
    </div>
  );
}
